"use client";

import Link from "next/link";
import { ChevronRight } from "lucide-react";

export type BreadcrumbItem = {
  label: string;
  href?: string;
};

export function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav aria-label="Breadcrumb" className="animate-in fade-in slide-in-from-left-2 duration-300 px-0 mb-8 sm:mb-16">
      <ol className="flex flex-wrap items-center gap-2 text-sm text-brand-brand 3xl:text-lg pl-0">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <li key={index} className="flex items-center gap-2">
              {index > 0 && <ChevronRight className="w-4 h-4 opacity-60" />}

              {item.href && !isLast ? (
                <Link
                  href={item.href}
                  className="hover:text-brand-teal transition-colors font-medium !3xl:text-lg"
                >
                  {item.label}
                </Link>
              ) : (
                <span
                  className={`${
                    isLast ? "text-brand-teal font-semibold 3xl:text-lg" : "text-brand-card 3xl:text-lg"
                  }`}
                >
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
